$(document).on('ready', function(){
    if ($(window).width() < 768) {
        // let croseeSellCarousel = $('#crosssell-products');
        // let carousel = croseeSellCarousel.flickity({
        //     lazyLoad: 2,
        //     initialIndex: 0,
        //     wrapAround: true,
        //     pageDots : true,
        //     freeScroll: true,
        //     contain: false,
        //     prevNextButtons: false,
        //     cellAlign: "left"
        // });
        var elem = document.getElementById('crosssell-products');
        var flkty = new Flickity( elem, {
            // options
            lazyLoad: 2,
            initialIndex: 0,
            wrapAround: true,
            pageDots : true,
            freeScroll: false,
            contain: false,
            prevNextButtons: false,
            cellAlign: "left"
        });
    }

    $('.crosssells .sons-product .link').on('click', function(){
       let elem = $(this);
       let self = $(this).parent().parent();
       let before = self.find('.before-link');
       let after = self.find('.after-link');
        if (self.hasClass('before')) {
            after.removeClass('active');
            before.addClass('active');
            self.removeClass('before').addClass('after');
        } else {
            before.removeClass('active');
            after.addClass('active');
            self.removeClass('after').addClass('before');
        }
    });

});
